import Service from "../../../service/api-competency.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {

        item:[],
        isReload: false,
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },

        isReload(state, obj) {
            state.isReload = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.Report_Method('report_method', data, {})
                .then((response) => {
                    store.commit("rMethod/item", response.data.data)
                    store.commit("assessment/isReload",true)

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.assessment('post', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
        update({commit}, data) {
            Service.assessment('put', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },

        remove({commit}, data) {
            store.commit("dialog/loading",true)
            Service.assessment('delete', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    store.commit("assessment/isReload",true)

                }).catch((err) => {
            });
        },

    },

    getters: {
        item(state, obj) {
            return state.item;
        },

        isReload(state, obj) {
            return state.isReload;
        }
    },
};

export default ServerModule;
